import { LoginHistoryApi } from "@/features/user/services/login-history-api";
import { LoginHistoryRequestModel, LoginHistoryResponseModel } from "@/features/user/services/login-history-model";

export class LoginHistoryService {
  private loginHistoryApi = new LoginHistoryApi();

  /**
   * ログイン履歴の取得
   */
  public async getLoginHistory(param: LoginHistoryRequestModel): Promise<LoginHistoryResponseModel[]> {
    return await this.loginHistoryApi.getLoginHistory(param);
  }
}